import { motion } from "framer-motion";
import { PawPrint } from "lucide-react";
import { SectionHeading } from "./Story";
import { SmartImage } from "./SmartImage";
import { imgSrc, imgStyle } from "@/lib/img";

export const RumiCorner = ({ rumi }) => {
  if (!rumi || !rumi.enabled) return null;

  return (
    <section id="rumi" className="py-20 sm:py-28 lg:py-32 bg-[var(--surface)]" data-testid="rumi-section">
      <div className="max-w-5xl mx-auto px-4 sm:px-8 lg:px-16">
        <SectionHeading script={rumi.subtitle || "our best boy"} title={rumi.title || "Rumi's Corner"} testid="rumi-heading" />
        <div className={`grid gap-12 items-center ${rumi.image ? "md:grid-cols-2" : "md:grid-cols-1 max-w-2xl mx-auto text-center"}`}>
          {rumi.image && (
          <motion.div
            initial={{ opacity: 0, x: -30 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }} transition={{ duration: 0.7 }}
            className="relative"
          >
            <div className="rounded-2xl w-full h-[300px] sm:h-[440px] overflow-hidden shadow-xl" data-testid="rumi-image">
              <img
                src={imgSrc(rumi.image)}
                style={imgStyle(rumi.image)}
                alt={rumi.name || "Rumi"}
                loading="lazy"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="absolute -bottom-4 -left-4 bg-[var(--card)] rounded-full px-5 py-2.5 shadow-lg flex items-center gap-2 border border-[var(--border)]">
              <PawPrint className="w-4 h-4 text-[var(--gold)]" />
              <span className="font-serif italic text-lg text-[var(--burgundy)]">{rumi.name || "Rumi"}</span>
            </div>
          </motion.div>
          )}
          <motion.div
            initial={{ opacity: 0, x: 30 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }} transition={{ duration: 0.7, delay: 0.1 }}
          >
            <p className="text-[var(--text-secondary)] text-base sm:text-lg leading-relaxed whitespace-pre-line" data-testid="rumi-description">
              {rumi.description}
            </p>
          </motion.div>
        </div>

        {rumi.photos?.length > 0 && (
          <div className="columns-2 md:columns-3 gap-4 sm:gap-5 mt-14 max-w-5xl mx-auto [column-fill:balance]" data-testid="rumi-photos">
            {rumi.photos.filter((p) => p.url).map((p, i) => (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-40px" }}
                transition={{ duration: 0.6, delay: (i % 3) * 0.08 }}
                className="mb-4 sm:mb-5 break-inside-avoid group"
              >
                <div className="overflow-hidden rounded-2xl transition-transform duration-500 group-hover:-translate-y-1 group-hover:shadow-xl">
                  <SmartImage src={p.url} aspect={p.aspect || "square"} fit={p.fit} focal={p.focal} position={p.position} zoom={p.zoom} alt={`${rumi.name || "Rumi"} ${i + 1}`} className="group-hover:scale-[1.03] transition-transform duration-500" testid={`rumi-photo-${i}`} />
                </div>
              </motion.div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
};
